import { Button, IconButton, Paper, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import { attachment_searchSQL } from "src/components/attachments/AttachmentFunctions";
import AttachmentViewerModal from "src/components/AttachmentViewer/AttachmentViewerModal";
import { CloseIcon } from "src/components/icons/ActionIcons";
import { PdfIcon } from "src/components/icons/MediaIcons";
import { SearchIcon } from "src/components/icons/SearchIcons";
import { parseJSONDate, pvmStringLong } from "src/components/js/statics1";
import KeikkaViewerModal from "src/components/keikka/keikkaViewer/KeikkaViewerModal";
import MyDivider from "src/components/layout/MyDivider";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import { useUserData } from "src/context/userContext";

export default function Attachments_search({
  variant = "standard",
  label = "Liitehaku",
  size = "medium",
}) {
  const { userAsiakas, token } = useUserData();
  const [isLoading, setIsLoading] = useState(false);
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [selectedAttachment, setSelectedAttachment] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [isAttOpen, setIsAttOpen] = useState(false);
  const [isKeikkaOpen, setIsKeikkaOpen] = useState(false);

  const handleSearchKlik = async () => {
    setIsLoading(true);
    const r = await attachment_searchSQL(userAsiakas.asiakasId, inputValue, token);
    setAttachmentsList(r);
    setIsLoading(false);
  };

  const handleKeyDown = (e) => e.key === "Enter" && handleSearchKlik(e);
  const handleCloseViewerKlik = () => {
    setSelectedAttachment(null);
    setIsAttOpen(false);
  };
  const handleOpenAttKlik = (att) => {
    setSelectedAttachment(att);
    setIsAttOpen(true);
  };
  const handleOpenKeikkaKlik = (att) => {
    setSelectedAttachment(att);
    setIsKeikkaOpen(true);
  };
  const handleCloseKeikkaKlik = () => {
    setSelectedAttachment(null);
    setIsKeikkaOpen(false);
  };
  const handleClearResultsKlik = () => {
    setAttachmentsList([]);
    setInputValue("");
  };

  return (
    <div style={{ position: "relative" }}>
      <AttachmentViewerModal
        onClose={handleCloseViewerKlik}
        open={isAttOpen}
        attachmentId={selectedAttachment?.attachmentId}
      />
      <KeikkaViewerModal
        onClose={handleCloseKeikkaKlik}
        open={isKeikkaOpen}
        keikkaId={selectedAttachment?.keikkaId}
      />
      <div className="center">
        <TextField
          value={inputValue}
          onKeyDown={handleKeyDown}
          onChange={(e) => setInputValue(e.target.value)}
          label={label}
          variant={variant}
          size={size}
          fullWidth
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: { autoComplete: "off" },
            input: {
              autoComplete: "off",
            },
          }}
        />
        <Button
          sx={{ height: "50px" }}
          disabled={isLoading || !inputValue}
          variant="outlined"
          color="primary"
          onClick={handleSearchKlik}>
          <SearchIcon />
        </Button>
      </div>
      <ProgressBar show={isLoading} height={2} />
      {attachmentsList.length > 0 && (
        <Paper
          style={{
            position: "fixed",
            top: "10%",
            left: "10%",
            right: "10%",
            bottom: "10%",
            overflowY: "auto",
            padding: "10px",
            zIndex: 1000,
          }}>
          <div className="spaceBetween">
            <div>Tulokset</div>
            <IconButton size="small" onClick={handleClearResultsKlik}>
              <CloseIcon />
            </IconButton>
          </div>
          <MyDivider />

          {attachmentsList.map((att) => (
            <div key={att.attachmentId} className="flexRow" style={{ width: "100%" }}>
              <div className="spaceBetween" style={{ width: "100%" }}>
                <div>
                  <div className="spaceBetween" style={{ width: "100%", gap: 10 }}>
                    <Typography variant="body">
                      {pvmStringLong(parseJSONDate(att.attachTime))}
                    </Typography>
                    <Typography variant="body2">{att.origFileName}</Typography>
                  </div>
                  <Typography>{att.fileComment}</Typography>
                  <Typography>Tilaus:{att.keikkaId}</Typography>
                </div>
                <div>
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpenAttKlik(att)}>
                    <PdfIcon /> Näytä pdf
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpenKeikkaKlik(att)}>
                    Näytä tilaus
                  </Button>
                </div>
              </div>
              <MyDivider />
            </div>
          ))}
        </Paper>
      )}
    </div>
  );
}

Attachments_search.propTypes = {
  variant: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  disableClearable: PropTypes.bool,
  height: PropTypes.number,
  onSelect: PropTypes.func,
  shrinkLabel: PropTypes.bool,
};
